import {Badge} from "@mantine/core";

// EmissionState (FNP-533, narrowed by FNP-814): PENDING / EMITTED / FAILED / UNCERTAIN.
// There is deliberately no RETRY — retry is expressed as the reconciler's re-drive and the
// requeue mutation, never as a state a row sits in. See billable-events.graphql.
export const StatusBadge = ({status}: { status: string }) => {
    let color = 'gray';
    if (status === 'EMITTED') {
        color = 'green';
    } else if (status === 'PENDING') {
        color = 'gray';
    } else if (status === 'FAILED') {
        color = 'red';
    } else if (status === 'UNCERTAIN') {
        color = 'orange';
    } else if (status === 'WRITTEN_OFF') {
        // FNP-1714: terminal, an admin decided this row will never bill.
        color = 'grape';
    }
    return <Badge color={color}>{status}</Badge>;
};
